import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { NgbCollapse, NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WebMonthAttendanceService } from '../../Model/WebMonthAttendance/web-month-attendance.service';
import { EditAttendanceComponent } from '../edit-attendance/edit-attendance.component';
import { ViewSummaryComponent } from '../view-summary/view-summary.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-web-month-attendance',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgSelectModule, DataTablesModule, NgbModule, NgbCollapse],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './web-month-attendance.component.html',
  styleUrl: './web-month-attendance.component.scss'
})
export class WebMonthAttendanceComponent {
  isDisabled: boolean = false;
  public User: any = null;
  BranchMasterLoad: any[] = []
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  selectedMonth: any = null;
  selectedMonthFormatted: any = null;
  TableDatas: any[] = [];
  isCollapsed: boolean = false;

  Detail = {
    SELECTTYPE: 0,
    MONTHNAME: null,
    YEARNAME: null,
    BRANCHID: null,
    CLIENTID: null,
    SITEID: null,
    EMPTYPE: 'FRONT',
    EMPCODE: null,
    EMPMASTERID: null,
    From: null as any,
    To: null as any,
    FROMDATE: null as any,
    TODATE: null as any
  }
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private sessionService: SessionService,
    private toast: ToastService,
    private comboload: ComboService,
    private getmonthattendance: WebMonthAttendanceService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsPrint = true;
    // this.common.PageRight.IsDelete = true;

    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.getData();
      // const [a, b] = this.selectedMonthFormatted.split(' ');
      // console.log('month ', a, '---', 'year', b)
    } else {
      this.toast.show({ message: "Select all mandatory fields.", type: toastTypeEnum.danger })
      form.submitted = true;
    }
  }

  getData() {
    this.isDisabled = true;
    // const [a, b] = this.selectedMonthFormatted.split(' ');
    this.Detail.SELECTTYPE = 1
    // this.Detail.MONTHNAME = a
    // this.Detail.YEARNAME = b;
    this.Detail.FROMDATE = this.dateFormat.format(this.Detail.From);
    this.Detail.TODATE = this.dateFormat.format(this.Detail.To);
    this.getmonthattendance.GetMonthlyAttendanceSummary(this.Detail).subscribe({
      next: (response) => {
        if (response) {
          if (response.Table.length == 0) {
            this.toast.show({ message: "No Data Found", type: toastTypeEnum.warning })
          }
          this.TableDatas = Object.values(response.Table);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          //   dtInstance.destroy();

          //   this.TableDatas = []; // important
          //   this.TableDatas = Object.values(response.Table);

          //   this.dtTrigger.next(null);
          // });
          // this.isDisabled = false;
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site') ? this.Detail.BRANCHID : 0,
      'ClientId': (Combotype == 'Site') ? this.Detail.CLIENTID : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMasterLoad = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  onNavigate() {
    this.updateFormattedMonthYear();
    console.log(this.selectedMonthFormatted);
  }
  updateFormattedMonthYear() {
    if (this.selectedMonth && this.selectedMonth.year && this.selectedMonth.month) {
      const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
      this.selectedMonthFormatted = new Intl.DateTimeFormat('en-US', options).format(startFromDate);
    }
  }

  EditAttandance(element: any) {
    if (this.common.PageRight.IsView) {
      // const [a, b] = this.selectedMonthFormatted.split(' ');
      const modalRef = this.modalService.open(EditAttendanceComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.InputData = {
        MONTHNAME: '',
        YEARNAME: '',
        BRANCHID: this.Detail.BRANCHID,
        CLIENTID: this.Detail.CLIENTID,
        SITEID: this.Detail.SITEID,
        EMPTYPE: 'FRONT',
        EMPCODE: this.Detail.EMPCODE,
        EMPMASTERID: element.EmpMasterID,
        EmpName: element.FULLNAME,
        Empcode: element.EMPCODE,
        DesignationName: element.DesignationName,
        Photo: element.Photo,
        FROMDATE: this.dateFormat.format(this.Detail.From),
        TODATE: this.dateFormat.format(this.Detail.To),
        EMPSITEID: element.SiteID,
        EMPSITENAME: element.SiteName
      };

      modalRef.result.then((result: any) => {
        if (result) {
          this.getData();
        }
      })

    }
  }

  onchange(type: string) {
    // if (type === 'Date') {
    //   this.TableDatas = []
    //   if (this.dtElement.dtInstance) {
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //   }
    // } else if (type === 'Branch') {
    //   this.TableDatas = [];
    //   if (this.dtElement.dtInstance) {
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //   }
    //   // this.Filter.ClientID = []
    //   // this.Clients = [];
    //   // this.Filter.SiteID = [];
    //   // this.Sites = []
    // } else if (type === 'Client') {
    //   this.TableDatas = [];
    //   if (this.dtElement.dtInstance) {
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //   }
    //   // this.Filter.SiteID = [];
    //   // this.Sites = []
    // } else if (type === 'site') {
    //   this.TableDatas = []
    //   if (this.dtElement.dtInstance) {
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //   }
    // }
  }
  ViewAttandance() {
    console.log(this.Detail.From);
    if (this.Detail.From == '' || this.Detail.From == null || this.Detail.To == '' || this.Detail.To == null) {
      this.toast.show({ message: 'Kindly Select Mandatory Fields', type: toastTypeEnum.warning });
      return;
    }
    if (this.common.PageRight.IsView) {
      // const [a, b] = this.selectedMonthFormatted.split(' ');
      const modalRef = this.modalService.open(ViewSummaryComponent, { centered: true, backdrop: 'static', size: 'lg' });
      modalRef.componentInstance.InputData = {
        // MONTHNAME: a,
        // YEARNAME: b,
        FROMDATE: this.dateFormat.format(this.Detail.From),
        TODATE: this.dateFormat.format(this.Detail.To),
        BRANCHID: this.Detail.BRANCHID,
        CLIENTID: this.Detail.CLIENTID,
        SITEID: this.Detail.SITEID,
        EMPTYPE: 'FRONT',
        EMPCODE: this.Detail.EMPCODE,
        EMPMASTERID: this.Detail.EMPMASTERID,
        EmpName: '',
        Empcode: this.Detail.EMPCODE,
        DesignationName: '',
        Photo: '',
      };
    }
  }

  clearGrid() {
    this.TableDatas = []
    if (this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }
}
